import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import ClassificationMeter from '@components/charts/classificationMeter/index'
import { StatusContainer, ClassificationContainer } from '../styles'

const engagementBeneficiaryStatus = ({
  engagementBeneficiaryData, status, onChange, loading, beneficiaryWithCollectionCount
}) => {
  const { activeAccounts, frequentAccessApp } = engagementBeneficiaryData || 0

  return (
    <StatusContainer>
      <ClassificationContainer>
        <ClassificationMeter
          loading={loading}
          type="activeAccounts"
          status={status}
          onSelect={onChange}
          value={activeAccounts}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="frequentAccessApp"
          status={status}
          onSelect={onChange}
          value={frequentAccessApp}
          maxValue={activeAccounts}
        />
      </ClassificationContainer>

    </StatusContainer>
  )
}

engagementBeneficiaryStatus.propTypes = {
  loading: PropTypes.bool,
  engagementBeneficiaryData: PropTypes.shape({
    activeAccounts: PropTypes.number,
    frequentAccessApp: PropTypes.number,
  }),
  status: PropTypes.shape({
    activeAccounts: PropTypes.bool,
    frequentAccessApp: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  beneficiaryWithCollectionCount: PropTypes.number
}

engagementBeneficiaryStatus.defaultProps = {
  engagementBeneficiaryData: null,
  loading: false,
  beneficiaryWithCollectionCount: 0
}

const mapStateToProps = ({ overview, beneficiary }) => ({
  engagementBeneficiaryData: overview.engagementBeneficiaryData,
  beneficiaryWithCollectionCount: beneficiary.beneficiaryWithCollectionCount

})

export default connect(mapStateToProps, null)(engagementBeneficiaryStatus)
